const typographyModalEquipServiceGroup = {
  true: 'Criar',
  false: 'Editar',
  text: 'Seção'
};

export default typographyModalEquipServiceGroup;
